import style from "./LoadingSpinner.module.css";

const LoadingSpinner = () => {
	return <div className={style.spinner}></div>;
};

export default LoadingSpinner;
